import React, { useState, useMemo, useLayoutEffect } from "react";
import { Stack } from "@mui/material";
import FilterContainer from "../FilterContainer";
import { IFilterProps } from "../../../../types/filter.type";
import FilterText from "../FilterText";
import FilterSelectApi from "../FilterSelectApi";
import { useSelector } from "react-redux";

function FilterForum({ setCondition }: IFilterProps) {
  const { rights, profile } = useSelector((state: any) => state.auth);
  const originFilter: { [key: string]: any } = {
    user: null,
    title: "",
    topic: null,
    category: null,
  };
  const [filter, setFilter] = useState(originFilter);

  const handleRefreshFilter = () => {
    setFilter(originFilter);
  };

  const categoryIds: string[] = useMemo(() => {
    const right = rights.find((r: any) => r.module === "forumposts");
    const ids = right?.viewOfOther_user_groups || [];
    return ids;
  }, [rights]);

  useLayoutEffect(() => {
    const condition: { [key: string]: any } = {};
    if (filter.user) {
      condition.user_created = filter.user.email;
    }
    if (filter.title) {
      condition.title = {
        $regex: filter.title?.split(" ")?.join(".*"),
        $options: "i",
      };
    }
    if (filter.topic) {
      condition.topic = filter.topic._id;
    }
    if (profile?.admin_app) {
      condition.category = filter.category?._id;
    } else {
      if (filter.category) {
        condition.category = filter.category?._id;
      } else {
        condition.category = { $in: categoryIds };
      }
    }
    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, categoryIds]);

  return (
    <FilterContainer handleRefreshFilter={handleRefreshFilter}>
      <Stack sx={{ width: "100%" }} spacing="10px">
        <FilterText
          title="Tiêu đề"
          placeholder="Tìm theo tiêu đề"
          value={filter.title}
          onSearch={(value) => setFilter({ ...filter, title: value })}
        />
        <FilterSelectApi
          direction="column"
          title="Danh mục"
          apiCode="socialcategories"
          placeholder="Chọn danh mục"
          value={filter.category}
          searchFields={["name"]}
          defaultCondition={
            profile?.admin_app
              ? { parentId: { $nin: ["", null] } }
              : {
                  parentId: { $nin: ["", null] },
                  _id: { $in: categoryIds || [] },
                }
          }
          getOptionLabel={(option) => option.name}
          checkEqual={(value, option) => value?._id === option?._id}
          onChange={(value) => setFilter({ ...filter, category: value })}
        />
        <FilterSelectApi
          direction="column"
          title="Người đăng"
          apiCode="participant"
          placeholder="Chọn người đăng"
          value={filter.user}
          searchFields={["name", "email"]}
          getOptionLabel={(option) => `${option.email} (${option.name})`}
          checkEqual={(value, option) => value?.email === option?.email}
          onChange={(value) => setFilter({ ...filter, user: value })}
        />
        <FilterSelectApi
          direction="column"
          title="Chủ đề"
          apiCode="topics"
          placeholder="Chọn chủ đề"
          value={filter.topic}
          searchFields={["name"]}
          getOptionLabel={(option) => option.name}
          checkEqual={(value, option) => value?._id === option?._id}
          onChange={(value) => setFilter({ ...filter, topic: value })}
        />
      </Stack>
    </FilterContainer>
  );
}

export default FilterForum;
